var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-block"},[_c('img',{style:({width:_vm.imgWidth}),attrs:{"src":require("@/assets/img/base/empty.png")}}),_c('div',[_vm._v(_vm._s(_vm.info))])])
}
var staticRenderFns = []

export { render, staticRenderFns }